var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('v-container',[_c('BreadCrumbs',{attrs:{"items":_vm.generateItems()}}),_c('ResultsComponent')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }